import { createContext, useContext, useState, useCallback } from "react";
import { ProgressLink } from "./ProgressLink";

const ProgressContext = createContext();

export const useProgress = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error("useProgress must be used within a ProgressProvider");
  }
  return context;
};

export const ProgressProvider = ({ children }) => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSchedules = useCallback(async (datetime, distance) => {
    setLoading(true);
    setError(null);
    try {
      const link = new ProgressLink();
      await link.request(datetime, distance);
      setSchedules(link.schedules);
    } catch (error) {
      console.error("Failed to fetch rounds:", error);
      setError(error.message);
      setSchedules([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const value = {
    schedules,
    loading,
    error,
    fetchSchedules,
  };

  return (
    <ProgressContext.Provider value={value}>
      {children}
    </ProgressContext.Provider>
  );
};
